import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';

import {
  PortalSearchComponent
} from './portal-search.component';

// This module exists for the portal-search because it contains an element for Sofi that is not valid HTML
// and not known to Angular, hence we must add the NO_ERRORS_SCHEMA, but we don't want to add it for any other
// components.
@NgModule({
  imports: [
  ],
  declarations: [
    PortalSearchComponent
  ],
  exports: [
    PortalSearchComponent
  ],
  providers: [
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ],
})
export class PortalSearchModule {
  constructor() { }
}
